import { jsx as _jsx } from "react/jsx-runtime";
export var TranslateTags = {
    b: function (chunks) { return _jsx("strong", { children: chunks }, chunks); },
    i: function (chunks) { return _jsx("em", { children: chunks }, chunks); },
    u: function (chunks) { return _jsx("u", { children: chunks }, chunks); },
    s: function (chunks) { return _jsx("s", { children: chunks }, chunks); },
};
